import React from 'react';
import { cn } from '../../utils/cn';

interface DesktopGameLayoutProps {
  chartContent: React.ReactNode;
  cluesContent: React.ReactNode;
  controlsContent: React.ReactNode;
  className?: string;
}

/**
 * DesktopGameLayout component - true 3-column grid layout
 *
 * Column 1 (37.5%): Price chart + header
 * Column 2 (37.5%): Financial clues + company hints
 * Column 3 (25%): Guess controls
 */
export const DesktopGameLayout: React.FC<DesktopGameLayoutProps> = ({
  chartContent,
  cluesContent,
  controlsContent,
  className
}) => {
  return (
    <div
      className={cn(
        "hidden lg:grid",
        "lg:grid-cols-[37.5%_37.5%_25%] lg:gap-0 lg:divide-x lg:divide-gray-300 dark:lg:divide-border",
        "w-full",
        "max-h-[calc(100vh-var(--header-height,4rem))]",
        className
      )}
      role="main"
      aria-label="Desktop dashboard layout"
    >
      {/* Column 1: Chart */}
      <div
        className="overflow-y-auto min-h-0 bg-[hsl(var(--dashboard-chart-background))] pt-2 pl-6 pb-6 pr-2 xl:pt-3 xl:pl-8 xl:pb-8 xl:pr-3 2xl:pt-4 2xl:pl-10 2xl:pb-10 2xl:pr-4 flex flex-col gap-4"
      >
        {chartContent}
      </div>

      {/* Column 2: Clues + Hints */}
      <div
        className="overflow-y-auto min-h-0 bg-[hsl(var(--dashboard-main-background))] pt-8 xl:pt-9 2xl:pt-10 px-4 xl:px-6 pb-4 xl:pb-6 space-y-6"
      >
        {cluesContent}
      </div>

      {/* Column 3: Controls */}
      <div
        className="overflow-y-auto min-h-0 bg-[hsl(var(--dashboard-sidebar-background))] p-6 xl:p-8 2xl:p-10 space-y-4 lg:space-y-6 xl:space-y-8 2xl:space-y-10 flex flex-col"
      >
        {controlsContent}
      </div>
    </div>
  );
};

export default DesktopGameLayout;
